export default "__VITE_PUBLIC_ASSET__893d5e07__"